import { useStore } from "zustand";

import { useLomdaV3Editor } from "../store/useLomdaV3Editor";

const pendingEdits = new Set<() => void>();

/** A rich-text field saves its typing on a timer. It registers how to save
 *  now, so undo / redo never run past an edit that isn't in the store yet. */
export function trackPendingEdit(save: () => void) {
    pendingEdits.add(save);
    return () => {
        pendingEdits.delete(save);
    };
}

function step(dir: "undo" | "redo") {
    pendingEdits.forEach((save) => save());
    useLomdaV3Editor.temporal.getState()[dir]();
}

export const undo = () => step("undo");
export const redo = () => step("redo");

/** Undo/redo wired to the zundo temporal history on the V3 store. */
export function useUndoRedo() {
    const canUndo = useStore(
        useLomdaV3Editor.temporal,
        (s) => s.pastStates.length > 0
    );
    const canRedo = useStore(
        useLomdaV3Editor.temporal,
        (s) => s.futureStates.length > 0
    );
    return { canUndo, canRedo, undo, redo };
}
